/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListSessionQuarantinesSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListSessionQuarantinesSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListSessionQuarantinesSecurity = {
  option1?: ListSessionQuarantinesSecurityOption1 | undefined;
  option2?: ListSessionQuarantinesSecurityOption2 | undefined;
};

export type ListSessionQuarantinesRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type ListSessionQuarantinesSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListSessionQuarantinesSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListSessionQuarantinesSecurityOption1$Outbound,
    ListSessionQuarantinesSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listSessionQuarantinesSecurityOption1ToJSON(
  listSessionQuarantinesSecurityOption1: ListSessionQuarantinesSecurityOption1,
): string {
  return JSON.stringify(
    ListSessionQuarantinesSecurityOption1$outboundSchema.parse(
      listSessionQuarantinesSecurityOption1,
    ),
  );
}

/** @internal */
export type ListSessionQuarantinesSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListSessionQuarantinesSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListSessionQuarantinesSecurityOption2$Outbound,
    ListSessionQuarantinesSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listSessionQuarantinesSecurityOption2ToJSON(
  listSessionQuarantinesSecurityOption2: ListSessionQuarantinesSecurityOption2,
): string {
  return JSON.stringify(
    ListSessionQuarantinesSecurityOption2$outboundSchema.parse(
      listSessionQuarantinesSecurityOption2,
    ),
  );
}

/** @internal */
export type ListSessionQuarantinesSecurity$Outbound = {
  Option1?: ListSessionQuarantinesSecurityOption1$Outbound | undefined;
  Option2?: ListSessionQuarantinesSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListSessionQuarantinesSecurity$outboundSchema: z.ZodMiniType<
  ListSessionQuarantinesSecurity$Outbound,
  ListSessionQuarantinesSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListSessionQuarantinesSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListSessionQuarantinesSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listSessionQuarantinesSecurityToJSON(
  listSessionQuarantinesSecurity: ListSessionQuarantinesSecurity,
): string {
  return JSON.stringify(
    ListSessionQuarantinesSecurity$outboundSchema.parse(
      listSessionQuarantinesSecurity,
    ),
  );
}

/** @internal */
export type ListSessionQuarantinesRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListSessionQuarantinesRequest$outboundSchema: z.ZodMiniType<
  ListSessionQuarantinesRequest$Outbound,
  ListSessionQuarantinesRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function listSessionQuarantinesRequestToJSON(
  listSessionQuarantinesRequest: ListSessionQuarantinesRequest,
): string {
  return JSON.stringify(
    ListSessionQuarantinesRequest$outboundSchema.parse(
      listSessionQuarantinesRequest,
    ),
  );
}
